export const LETTERS_AND_SPACES_REGEX = /^[A-Za-z]+(?:[A-Za-z ]*[A-Za-z])?$/;
export const DIGITS_ONLY_REGEX = /^\d+$/;
export const MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
export const EMAIL_REGEX = /^(?!\.)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const AADHAAR_REGEX = /^(?:\d{12}|\d{4} \d{4} \d{4})$/;

export const containsOnlyLettersAndSpaces = (value: string) =>
  LETTERS_AND_SPACES_REGEX.test(value.trim());

export const containsOnlyDigits = (value: string) => DIGITS_ONLY_REGEX.test(value);
export const isValidMobileNumber = (value: string) => MOBILE_NUMBER_REGEX.test(value);
export const isValidEmail = (value: string) => EMAIL_REGEX.test(value.trim());

export const sanitizeDigits = (value: string) => value.replace(/\D/g, "");
